import { render, staticRenderFns } from "./YA_Login.vue?vue&type=template&id=cb23458c&scoped=true"
import script from "./YA_Login.vue?vue&type=script&lang=js"
export * from "./YA_Login.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb23458c",
  null
  
)

export default component.exports